// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"de175e4a","360":"f15280af","603":"e6d33b84"}[chunkId] + ".chunk.js";
};